/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { NavLink, useHistory } from "react-router-dom";
// import SVG from "react-inlinesvg";
import { checkIsActive } from "../../../../_helpers";
import { getUserMenu } from "../../../../../api/menuApi";
import { useDispatch } from "react-redux";
import { menuActions } from "../../../../../redux/slices/menuSlice";
export function AsideMenuList({ layoutProps }) {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    // ref
    const controllerRef = useRef(null);

    // component state
    const [mainMenus, setMainMenus] = useState([]);
    const [subMenus, setSubMenus] = useState([]);

    // set redux state menu permission
    const setMenuPermission = useCallback(
        menuRes => {
            const mainMenus = menuRes?.mainMenus?.map(main => ({
                path: `/${main?.menuControlPart}`,
                permission: main?.permission,
            }));
            const sub1Menus = menuRes?.subMenus?.map(sub1 => ({
                path: `/${
                    menuRes?.mainMenus?.find(main => main?.menuControlMainSub === sub1?.menuControlMainSub)
                        ?.menuControlPart
                }/${sub1?.menuControlPart}`,
                permission: sub1?.permission,
            }));
            dispatch(menuActions.setMenuPermission({ menuPermission: [...mainMenus, ...sub1Menus] }));
        },
        [dispatch],
    );

    // find redirect menu
    const findRedirectMenu = useCallback(
        menuRes => {
            // find redirect first main menu
            const findFirstMainMenu = menuRes?.mainMenus?.find(item => item?.menuControlIndex === 0);

            // find redirect first sub menu
            const findSubMenusArray = menuRes?.subMenus?.filter(
                item => item?.menuControlMainSub === findFirstMainMenu?.menuControlMainSub,
            );
            const findFirstSubMenu = findSubMenusArray?.find(item => item?.menuControlIndex > 0);

            if (findFirstSubMenu) {
                dispatch(
                    menuActions.setRedirectRootMenu({
                        pathName: `/${findFirstMainMenu?.menuControlPart}/${findFirstSubMenu?.menuControlPart}`,
                    }),
                );
                if (location.pathname === "/") {
                    history.push(`/${findFirstMainMenu?.menuControlPart}/${findFirstSubMenu?.menuControlPart}`);
                }
            } else {
                dispatch(
                    menuActions.setRedirectRootMenu({
                        pathName: `/${findFirstMainMenu?.menuControlPart}`,
                    }),
                );
                if (location.pathname === "/") {
                    history.push(`/${findFirstMainMenu?.menuControlPart}`);
                }
            }
        },
        [dispatch, history, location.pathname],
    );

    // fetch data function
    const getData = useCallback(
        async signal => {
            try {
                const dataMenus = await getUserMenu(signal);
                if (dataMenus) {
                    setMenuPermission(dataMenus);
                    setMainMenus(dataMenus?.mainMenus);
                    setSubMenus(dataMenus?.subMenus);
                    findRedirectMenu(dataMenus);
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [setMenuPermission, findRedirectMenu],
    );

    // get menu class
    const getMenuItemActive = (url, hasSubmenu = false) => {
        return checkIsActive(location, url)
            ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open menu-item-not-hightlighted`
            : "";
    };

    // click main menu
    const handleClickMainMenu = useCallback(
        item => {
            const findSubMenus = subMenus.filter(sub => sub?.menuControlMainSub === item?.menuControlMainSub);
            if (["display"].includes(item?.menuControlPart)) {
                history.replace(`/${item?.menuControlPart}`);
                return;
            }
            if (findSubMenus.length > 0) {
                history.replace(`/${item?.menuControlPart}/${findSubMenus[0]?.menuControlPart}`);
            } else {
                history.replace(`/${item?.menuControlPart}`);
            }
        },
        [history, subMenus],
    );

    // run on first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        const fetch = async () => {
            await getData(controllerRef.current?.signal);
        };
        fetch();
        return () => {
            controllerRef.current.abort();
        };
    }, [getData]);

    return (
        <>
            {/* begin::Menu Nav */}
            <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                {/* Error Pages */}
                {mainMenus?.map(item => {
                    return (
                        <li
                            key={item?.id}
                            className={`menu-item menu-item-submenu ${getMenuItemActive(
                                `/${item?.menuControlPart}`,
                                true,
                            )}`}
                            aria-haspopup="true"
                            data-menu-toggle="hover">
                            <div className="menu-link menu-toggle" onClick={() => handleClickMainMenu(item)}>
                                <span className="svg-icon menu-icon">
                                    <i className={`${item?.menuControlIcon}`}></i>
                                </span>
                                <span className="menu-text">{item?.menuControlName}</span>
                                {/* <i className="menu-arrow" /> */}
                            </div>

                            <div className="menu-submenu ">
                                <i className="menu-arrow" />
                                <ul className="menu-subnav">
                                    <li className="menu-item  menu-item-parent" aria-haspopup="true">
                                        <span className="menu-link">
                                            <span className="menu-text">Error Pages</span>
                                        </span>
                                    </li>
                                    {subMenus?.map((item2, index) => {
                                        return item2?.menuControlMainSub === item?.menuControlMainSub ? (
                                            <li
                                                key={index}
                                                className={`menu-item ${getMenuItemActive(
                                                    `/${item?.menuControlPart}/${item2?.menuControlPart}`,
                                                )}`}
                                                aria-haspopup="true">
                                                <NavLink
                                                    className="menu-link"
                                                    to={`/${item?.menuControlPart}/${item2?.menuControlPart}`}>
                                                    <i className="menu-bullet menu-bullet-dot">
                                                        <span />
                                                    </i>
                                                    <span className="menu-text">{item2?.menuControlName}</span>
                                                </NavLink>
                                            </li>
                                        ) : null;
                                    })}
                                </ul>
                            </div>
                        </li>
                    );
                })}
            </ul>

            {/* end::Menu Nav */}
        </>
    );
}
